namespace TR {
    function Loading (
        $scope: any,
        $timeout: ng.ITimeoutService,
        resourceService: Core.ResourceService
    )
    {
        $timeout(() => {
            $scope.$emit('block', {
                title: resourceService.get('LOADINGRECOMMENDEDESTAB'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'hotels-hotelSearchCtrl-isHolidayFalse'
            });
        });
    }

    angular
        .module('TR')
        .controller('Loading', Loading);
}

